<template>
    <div class="contact">
		<div class="contact__header">
			<div class="contact__title	">
				<div class="contact__title_cn">联系我们 / </div>
				<div class="contact__title_en">Contact us</div>
				<img src='https://static.zc0901.com/dci-web-product-knowledge.png' class="contact__title_bottom" />
			</div>
			<div class="contact__info">公司地址：<span>江苏省苏州市工业园区旺墩路269号星座商务广场1幢2901室</span></div>
			<div class="contact__info">工厂地址：<span>S.S.610 Selice 1, 40027 Mordano (BO) Italy</span></div>
			<div class="contact__info contact__info__address">客服电话：<span>0512-87821001</span></div>
			<div class="contact__input">
				<el-input v-model="name" placeholder="姓名" @input="inputEnter('name',$event)"></el-input>
				<el-input v-model="mobile" placeholder="手机" @input="inputEnter('mobile',$event)"></el-input>
				<!-- <el-input v-model="email" placeholder="邮箱" @input="inputEnter('email',$event)"></el-input> -->
			</div>
			<div class="contact__address">
				<el-input v-model="address" type="textarea" :rows="4" placeholder="反馈" @input="inputEnter('address',$event)"></el-input>
			</div>
			<div class="contact__submit" @click="submit">提交</div>
		</div>
	</div>
</template>
<script>
import {mapActions} from 'vuex'
import { getToken } from '@/utils/cookies'
import './index.scss'

	export default {
		data() {
			return {
				name:'',
				mobile:'',
				address:''
			}
		},
		computed: {

		},
        created(){
            
        },
		mounted() {
		},
		methods: {
			...mapActions('common',['CONTACTUS']),
			// 输入框内容
			inputEnter(type,e){
				switch (type) {
					case 'name':
						this.name = e
						break;
					case 'mobile':
						this.mobile = e
						break;
					case 'address':
						this.address = e
						break;
					default:
						break;
				}
			},
			// 提交信息
			async submit(){
				// 没有登陆跳转登陆页面
                if( getToken('DCI_USER') == undefined ){
                    this.$message.error('您还没有登录，请先登录')
                    return this.$router.push({
                        path: `../login`
                    })
                } 
                // 登陆过
				if( this.name === '' || this.mobile === '' || this.address === '' ) {
					return this.$message.error('请完善信息')
				}	
				const regMobile = /^1[23456789][0-9]{9}$/;
				if (!regMobile.test(this.mobile)) {
					return this.$message.error('请输入正确手机号')
				}
				if (this.address.length < 5) {
					return this.$message.error('地址信息最少输入5个字')
				}
				let _data = {
					name: this.name,
					phone: this.mobile,
					address: this.address
				}
				const res = await this.CONTACTUS(_data)
				if( res.code === 200 ){
					// this.$message({
                    //     message: '成功提交信息',
                    //     type: 'success'
					// });
					this.$alert('感谢您提交的反馈建议，我们会尽快与您取得联系', '成功提交信息', {
						confirmButtonText: '确定',
						callback: action => {
							this.name === ''
							this.mobile === ''
							this.address === ''
						}
					});
					
				}
			}
		}
	}
</script>
<style lang="scss">
	.contact__input{
		.el-input__inner{
			width: 470px;
			background:rgba(19,26,37,1);
			border: none;
			font-size:18px;
			font-weight:600;
			color:rgba(153,153,153,1);
			line-height:22px;
			border-bottom: 1px solid rgba(73,89,112,1);
			border-radius: 0;
			padding: 0;
		}
	}
	.contact__address{
		.el-input__inner{
			width: 960px;
			background:rgba(19,26,37,1);
			border: none;
			font-size:18px;
			font-weight:600;
			color:rgba(153,153,153,1);
			line-height:22px;
			border-bottom: 1px solid rgba(73,89,112,1);
			border-radius: 0;
			padding: 0;
		}
		.el-textarea__inner{
			background:rgba(19,26,37,1);
			border: none;
			border: 1px solid #495970;
			color: #999999;
			font-size: 18px;
			font-weight: 600;
			resize:none;
		}
		.el-textarea{
			width: 966px;
		}
	}
</style>
